export function toggleHireUsModal() {
    document.querySelector("#hireUs").classList.toggle("hireUs__backdrop--active")
}
export function toggleSendCVModal() {
    document.querySelector("#sendCV").classList.toggle("hireUs__backdrop--active")
}